export const SUCCESS_URL = "https://happybati.web.app";
// export const SUCCESS_URL = "http://localhost:3000";
// export const success_url = 'https://happybati.web.app'
export const CANCEL_URL = "https://happybati.web.app";
// export const CANCEL_URL = "http://localhost:3000";
